import { getEnumValues } from './get-enum-values';
export enum Queue{
  WeeklySignupsReminderCronJob='CronJobs',
  ScoutingReportInviteReminderCronJob='ScoutingReportInviteReminderCronJob',
  RecurringNotifyServiceCronJob='RecurringNotifyServiceCronJob',
}
export const QueueValues = getEnumValues<Queue>(Queue);
